import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { validateUuid } from '@/utils/validate-uuid';
import { WorkerService } from '@/infra/services/worker';

interface GetWorkerParams {
	id: string;
	company_id: string;
	organization_id: string;
}

const Service = WorkerService.getInstance();

export const useGetWorker = (params: GetWorkerParams) => {
	const isEnabled = validateUuid([params.organization_id, params.company_id, params.id]);
	return useQuery({
		queryKey: [QUERY_KEYS.GET_WORKER, params],
		queryFn: async () => Service.show(params),
		enabled: isEnabled
	});
};
